import { IoArrowBackOutline, IoClose } from 'react-icons/io5';
import { customStyles } from '../Modal/ModalComponent';
import './TagFieldModal.css';
import Modal from 'react-modal';
import React, { useEffect, useRef, useState } from 'react';
import Button from '../Button/Button';
import { TagFieldConfig, TagFieldType } from '../../enums/fieldTypes';
import Input from '../Input/Input';
import ToggleButton from '../ToggleButton/ToggleButton';
import { HiPlus } from "react-icons/hi";
import { TagFieldInput } from '../TagFieldInput/TagFieldInput';
import { MdOutlineDelete } from 'react-icons/md';
import { LuCheck, LuPlus, LuX } from 'react-icons/lu';
import { toCamelCase } from '../../utils/string';
import Select from '../Select/Select';
import { v4 as uuidv4 } from 'uuid';
import { TagType } from '../../enums/tagTypes';

export const ModalState = {
	CLOSE: 1,
	FIELD_SELECTOR: 2,
	FORM: 3,
}

export function TagFieldModal({ onClose, field, tagType, modalMode, setModalMode, onSave, ...props }) {
	const [id, setId] = useState(null);
	const [name, setName] = useState();
	const [hint, setHint] = useState();
	const [required, setRequired] = useState(false);
	const [defaultValue, setDefault] = useState();
	const [minSize, setMinSize] = useState();
	const [maxSize, setMaxSize] = useState();
	const [isLicenseField, setIsLicenseField] = useState();
	const [type, setType] = useState();
	const [values, setValues] = useState([]);
	const [metadata, setMetadata] = useState();
	const [externalId, setExternalId] = useState();
	const [constraints, setConstraints] = useState();
	const [_modalMode, _setModalMode] = useState();

	const [addingValue, setAddingValue] = useState(false);
	const [newValue, setNewValue] = useState('');
	const newValueRef = useRef();

	useEffect(() => {
		if (addingValue && newValueRef.current) {
			newValueRef.current.focus();
		}
	}, [newValueRef.current, addingValue]);

	useEffect(() => {
		_setModalMode(modalMode);
		if (field) {
			setId(field.id || null);
			setExternalId(field.externalId || uuidv4())
			setName(field.name);
			setHint(field.hint);
			setRequired(field.required);
			setDefault(field.default);
			setMinSize(field.minSize);
			setMaxSize(field.maxSize);
			setIsLicenseField(field.isLicenseField || false);
			setType(field.type);
			setValues(field.values || []);
			setConstraints(field.constraints || []);
			setMetadata(field.metadata);
			setAddingValue(false);
			setNewValue('');
		} else if (modalMode === ModalState.FIELD_SELECTOR) {
			resetForm();
		}
	}, [field, modalMode]);

	function resetForm() {
		setId(null);
		setExternalId(null);
		setName(null);
		setHint(null);
		setRequired(false);
		setDefault(null);
		setMinSize(null);
		setMaxSize(null);
		setIsLicenseField(false);
		setType(null);
		setValues([]);
		setConstraints([]);
		setMetadata(null);
		setAddingValue(false);
		setNewValue('');
	}

	function handleClose() {
		resetForm();
		onClose();
	}

	function getModalTitle() {
		if (_modalMode === ModalState.FIELD_SELECTOR) {
			return 'Selecione o tipo do campo'
		}
		return `${name && name !== '' ? name : TagFieldConfig[type]?.name}`;
	}

	function addValue(value) {
		setAddingValue(false);
		setNewValue('');
		const valueKey = toCamelCase(value);
		setValues(prevValues => {
			if (!value || value === '' || prevValues.map(toCamelCase).includes(valueKey)) {
				return prevValues;
			}
			return [
				...prevValues,
				value,
			];
		})
	}

	function removeValue(idx) {
		if (values && values.length > idx) {
			setValues(prevValues => ([
				...prevValues.slice(0, idx),
				...prevValues.slice(idx + 1)
			]));
		}
	}

	return (
		<Modal
			isOpen={_modalMode !== ModalState.CLOSE}
			onRequestClose={handleClose}
			className="tag-field-modal-content"
			overlayClassName="tag-field-modal-overlay"
			style={{
				...customStyles,
				content: {
					...customStyles.content,
					padding: '36px',
				}
			}}
			contentLabel={getModalTitle()}
		>
			<div className='modal-header'>
				<h2>
					{type && (
						<>
							{React.createElement(TagFieldConfig[type].icon, {
								color: TagFieldConfig[type].color,
							})}
						</>
					)}
					{getModalTitle()}
				</h2>
				<div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
					{_modalMode === ModalState.FORM && !field && (
						<button type="button" className='back-button' onClick={(e) => {
							resetForm();
							setModalMode(ModalState.FIELD_SELECTOR);
						}}>
							<IoArrowBackOutline />
							Voltar
						</button>
					)}
					<button className="close-button" onClick={handleClose}><IoClose /></button>
				</div>
			</div>
			<div className='modal-body'>
				{_modalMode === ModalState.FIELD_SELECTOR ? (
					<div className='tag-type-wrapper'>
						{Object.entries(TagFieldConfig).map(([fieldType, fieldConfig]) => (
							<button
								key={fieldConfig.name}
								type='button'
								className='btn-tag-type'
								style={{ '--type-color': fieldConfig.color }}
								onClick={(e) => {
									setModalMode(ModalState.FORM);
									setType(Number(fieldType))
								}}
							>
								{React.createElement(fieldConfig.icon, {
									color: fieldConfig.color,
								})}
								<span>
									<span>{fieldConfig.name}</span>
									<span>{fieldConfig.description}</span>
								</span>
							</button>
						))}
					</div>
				) : (
					<div className='field-form'>
						<div className='grid-2'>
							<Input
								name="name"
								id="name"
								labelText="Nome *"
								value={name}
								onChange={({ target }) => setName(target.value)}
								disabled={props.type === "consulta"}
								required={true}
								tooltipText="Nome do campo, deve ser único para a tag"
								tooltipVisible={true}
							/>
							<Input
								name="hint"
								id="hint"
								labelText="Descrição *"
								value={hint}
								onChange={({ target }) => setHint(target.value)}
								disabled={props.type === "consulta"}
								required={true}
								tooltipText="Placeholder do campo, uma descrição"
								tooltipVisible={true}
							/>
						</div>
						<div className='grid-2' style={{ marginTop: 12 }}>
							<div>
								<p className='input-label' style={{ marginBottom: 4 }}>Padrão</p>
								{type === TagFieldType.SELECT && (!values || values.length === 0) ? (
									<p className='empty-text'>Nenhum valor</p>
								) : (
									<TagFieldInput
										fieldConfig={{
											id,
											name,
											hint,
											required,
											minSize,
											maxSize,
											type,
											values,
											constraints,
											metadata,
										}}
										value={defaultValue}
										onChange={(newValue) => setDefault(newValue)}
									/>
								)}

							</div>
							<ToggleButton
								label={`Obrigatório`}
								selected={required}
								onClick={() => setRequired(!required)}
								disabled={props.type === "consulta"}
								tooltipVisible={true}
								tooltipText={
									"Torna o campo obrigatório."
								}
							/>
						</div>
						{[TagFieldType.TEXT, TagFieldType.LONGTEXT, TagFieldType.NUMBER].includes(type) && (
							<div className='grid-2' style={{ marginTop: 12 }}>
								<Input
									name="minSize"
									id="minSize"
									type="number"
									labelText="Tamanho mínimo *"
									value={minSize}
									onChange={({ target }) => setMinSize(Number(target.value))}
									disabled={props.type === "consulta"}
								/>
								<Input
									name="maxSize"
									id="maxSize"
									type="number"
									labelText="Tamanho máximo *"
									value={maxSize}
									onChange={({ target }) => setMaxSize(Number(target.value))}
									disabled={props.type === "consulta"}
								/>
							</div>
						)}
						{type === TagFieldType.SELECT && (
							<div style={{ marginTop: 10 }}>
								<Select
									labelText={`Tipo de Seleção`}
									name={`selectionType`}
									value={`${metadata?.single || false}`}
									onChange={({ target }) => setMetadata(meta => ({
										...meta,
										single: target.value === 'true',
									}))}
									required={true}
									options={[
										{
											value: 'true',
											text: 'Singular',
										},
										{
											value: 'false',
											text: 'Múltipla',
										}
									]}
								/>
							</div>
						)}
						{type === TagFieldType.SELECT && (
							<div className='tag-field-values'>
								<div style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'space-between' }}>
									<h3 className='input-label' style={{ marginBottom: 5 }}>Valores</h3>
								</div>
								<div>
									{(!values || values.length === 0) && (
										<p className='empty-text'>Nenhum valor.</p>
									)}
									<div className="tag-field-container-values">
										{values?.map((value, idx) => (
											<div className="wrapper-tag-field-value" key={value}>
												<span>{value}</span>
												<button
													type="button"
													className="btn-delete-tag-field-value"
													onClick={(e) => removeValue(idx)}
												>
													<MdOutlineDelete size={18} />
												</button>
											</div>
										))}
										{addingValue ? (
											<>
												<input type='text' ref={newValueRef} onChange={(e) => setNewValue(e.target.value)} value={newValue} />
												<button type="button" className="btn-confirm-editing" onClick={e => { addValue(newValue) }}><LuCheck size={18} /></button>
												<button type="button" className="btn-cancel-editing" onClick={e => { setAddingValue(false) }}><LuX size={18} /></button>
											</>
										) : (
											<button type="button" className="btn-add-tag-field-value" onClick={(e) => setAddingValue(true)}><LuPlus size={18} /></button>
										)}
									</div>
								</div>
							</div>
						)}
						{tagType === TagType.PERSON && (
							<ToggleButton
								label={`Por Licença`}
								selected={isLicenseField}
								onClick={() => setIsLicenseField(prev => !prev)}
								disabled={props.type === "consulta"}
								tooltipVisible={true}
								tooltipText={
									"Define se o campo é por licença."
								}
							/>
						)}
					</div>
				)}
			</div>
			<div className='modal-footer'>
				{_modalMode === ModalState.FORM && (
					<>
						<Button className="button-white" label="Cancelar" onClick={handleClose} />
						<Button label="Salvar" onClick={e => {
							onSave({
								id,
								externalId: externalId || uuidv4(),
								name,
								hint,
								required,
								default: defaultValue,
								minSize,
								maxSize,
								isLicenseField,
								type,
								values,
								constraints,
								metadata,
								addingValue,
								newValue,
							});
							handleClose();
						}} />
					</>
				)}
			</div>
		</Modal>
	);
}